import React from "react";
import "../../../style/main.scss";
import laptop from "../../../assets/images/blog/Rectangle 123.png";
import whatsapp from "../../../assets/images/blog/Rectangle 125.png";
import instagram from "../../../assets/images/blog/Rectangle 127.png";
import low from "../../../assets/images/blog/Rectangle 124.png";
import little from "../../../assets/images/blog/Rectangle 126.png";
import clever from "../../../assets/images/blog/Rectangle 128.png";
import { useTranslation } from "react-i18next";

const Facebook = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="facebook">
        <h3>{t("facebook")}</h3>
        <div className="blog-parent">
          <div className="home-cards">
            <img src={laptop} alt="laptop" className="img-fluid" />
            <p>{t("The_Beginner’s_Guide")}</p>
          </div>
          <div className="home-cards">
            <img src={whatsapp} alt="laptop" className="img-fluid" />
            <p>{t("How_to_Create_Successful")}</p>
          </div>
          <div className="home-cards">
            <img src={instagram} alt="laptop" className="img-fluid" />
            {/* <p>
              How to import WhatsApp contacts into DMBOT and send a Broadcast
            </p> */}
            <p>{t("Facebook_Ad_Sizes")}</p>
          </div>
          <div className="home-cards">
            <img src={low} alt="low" className="img-fluid" />
            <p>{t("When_is_the_Best")}</p>
          </div>
          <div className="home-cards">
            <img src={little} alt="little" className="img-fluid" />
            <p>{t("How_to_Go_Live")}</p>
          </div>
          <div className="home-cards">
            <img src={clever} alt="clever" className="img-fluid" />
            <p>{t("Chatting_for_Conversions")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facebook;
